import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
function Header() {
  const [showMenu, setShowMenu] = useState("md:hidden");
  const navItems = [
    {
      title: "Home",
      key: "/",
    },
    {
      title: "Projects",
      key: "/projects",
    },
    {
      title: "Blog",
      key: "/blog",
    },
    {
      title: "Contact",
      key: "/contact",
    },
  ];
  function handleBurger() {
    if (showMenu === "md:hidden") {
      setShowMenu("");
    } else {
      setShowMenu("md:hidden");
    }
  }
  const pathname = window.location.pathname;
  return (
    <div className="text-white font-mont fixed top-0 left-0 right-0 z-50">
      <div
        className={`flex bg-black justify-between items-center p-2 shadow-xl w-full shadow-rb ${
          showMenu === "" && "md:flex-col"
        }`}
      >
        <div className="flex justify-between w-full items-center">
          <Link to='/'><h1 className="text-4xl font-semibold">L A E</h1></Link>
          <FaBars
            onClick={handleBurger}
            className=" lg:hidden xl:hidden hidden md:flex text-2xl cursor-pointer"
          />
        </div>

        <div className="flex md:hidden items-center">
          {navItems.map((item) => {
            return (
              <li
                key={item.key}
                className={`list-none mx-5 ${
                  item.key == pathname && "bg-white text-black rounded-md p-1"
                }`}
              >
                <Link to={`${item.key}`}>{item.title}</Link>
              </li>
            );
          })}
        </div>
        <div
          className={`md:flex items-start w-full md:flex-col hidden  ${showMenu}`}
        >
          {navItems.map((item) => {
            return (
              <li
                key={item.key}
                className={`list-none px-3 my-1 p-1 ${
                  item.key == pathname && "bg-white text-black rounded-md p-1"
                }`}
              >
                <Link to={`${item.key}`}>{item.title}</Link>
              </li>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Header;
